<template>
  <vx-card id="loader">
    <h3>Отладка DSP - баннеры</h3>

    <form>
      <div class="vx-row mt-1">
        <div class="vx-col w-1/2">
          <div class="mt-1">
            <vs-input
                v-model="form.requestID"
                autocomplete="off"
                label="ID запроса"
                placeholder="Введите ID запроса..."
                class="mt-1 w-full"
            />
          </div>
        </div>
        <div class="vx-col w-1/2 mb-1">
          <div class="mt-1">
            <vs-input
                v-model="form.userID"
                autocomplete="off"
                label="ID пользователя"
                placeholder="Введите ID пользователя..."
                class="mt-1 w-full"
            />
          </div>
        </div>
      </div>

      <div class="vx-row mt-1">
        <div class="vx-col w-1/4">
          <div class="mt-1">
            <vs-input
                v-model="form.width"
                autocomplete="off"
                label="Ширина"
                placeholder="Введите ширину..."
                class="mt-1 w-full"
            />
          </div>
        </div>
        <div class="vx-col w-1/4">
          <div class="mt-1">
            <vs-input
                v-model="form.height"
                autocomplete="off"
                label="Высота"
                placeholder="Введите высота..."
                class="mt-1 w-full"
            />
          </div>
        </div>
        <div class="vx-col w-1/2 mb-1">
          <div class="mt-1">
            <vs-input
                v-model="form.siteID"
                autocomplete="off"
                label="ID Сайта"
                placeholder="Введите название..."
                class="mt-1 w-full"
            />
          </div>
        </div>
      </div>

      <div class="vx-row mt-1">
        <div class="vx-col w-1/2">
          <div class="mt-1">
            <vs-input
                v-model="form.ip"
                autocomplete="off"
                label="IP (по нему будет определена страна)"
                placeholder="Введите ip..."
                class="mt-1 w-full"
            />
          </div>
        </div>
        <div class="vx-col w-1/2 mb-1">
          <div class="mt-1">
            <vs-input
                v-model="form.domain"
                autocomplete="off"
                label="Домен сайта"
                placeholder="Введите домен..."
                class="mt-1 w-full"
            />
          </div>
        </div>
      </div>

      <div class="vx-row mt-1">
        <div class="vx-col w-1/2">
          <div class="mt-1">
            <label class="vs-input--label"> SSP </label>
            <v-select :options="dictionary.ssp" placeholder="Выберите тип SSP" class="w-full" v-model="form.ssp">
            </v-select>
          </div>
        </div>
        <div class="vx-col w-1/2 mb-1">
          <div class="mt-1">
            <label class="vs-input--label"> Устройства </label>
            <v-select :options="dictionary.devices" placeholder="Выберите устройства" class="w-full" v-model="form.device">
            </v-select>
          </div>
        </div>
      </div>

      <!-- <div class="vx-row mt-1">
        <div class="vx-col w-1/2">
          <div class="mt-1">
            <label class="vs-input--label"> Возрастной рейтинг </label>
            <v-select :options="dictionary.ageRates" multiple placeholder="Выберите возрастной рейтинг" class="w-full" v-model="form.ageRates">
            </v-select>
          </div>
        </div>

        <div class="vx-col w-1/2 mb-1">
          <div class="mt-1">
            <label class="vs-input--label"> Тип контента </label>
            <v-select :options="dictionary.contents"  multiple placeholder="Выберите тип контента" class="w-full" v-model="form.contents">
            </v-select>
          </div>
        </div>
      </div> -->

      <div class="vx-row mt-1">
        <div class="vx-col w-1/2 mb-1">
          <div class="mt-1">
            <label class="vs-input--label"> Страна </label>
            <v-select :options="dictionary.countries"  placeholder="Выберите страна" class="w-full" v-model="form.country">
            </v-select>
          </div>
        </div>
        <div class="vx-col w-1/2 mb-1">
          <div class="mt-1">
            <vs-input
                v-model="form.blockID"
                autocomplete="off"
                label="ID блока"
                placeholder="Введите ID блока..."
                class="mt-1 w-full"
            />
          </div>
        </div>
      </div>

      <!-- <div class="vx-row mt-1">
        <div class="vx-col w-1/4">
          <div class="mt-1">
            <vs-input
                v-model="form.attributes"
                autocomplete="off"
                label="Аттрибуты DMP"
                placeholder="Введите аттрибуты через запятую."
                class="mt-1 w-full"
            />
          </div>
        </div>
          <div class="vx-col w-1/4">
          <div class="mt-1">
            <vs-input
                v-model="form.adTags"
                autocomplete="off"
                label="Теги"
                placeholder="Введите теги через запятую."
                class="mt-1 w-full"
            />
          </div>
        </div>
        <div class="vx-col w-1/4">
          <div class="mt-1">
            <vs-input
                v-model.number="form.placesCount"
                type="number"
                autocomplete="off"
                label="Количество мест в imp"
                placeholder="Введите число..."
                class="mt-1 w-full"
            />
          </div>
        </div>
      </div> -->

      <div class="vx-row mt-1">
        <div class="vx-col w-1/2">
          <div class="mt-1">
            <vs-input
                v-model="form.userAgent"
                autocomplete="off"
                label="User-agent"
                placeholder="Введите параметры user-agent"
                class="mt-1 w-full"
            />
          </div>
        </div>
         <div class="vx-col w-1/2">
          <div class="mt-1">
            <label class="vs-input--label"> Язык браузера </label>
              <v-select :options="dictionary.languages"  :clearable="false" placeholder="Выберите язык браузера" class="w-full" v-model="form.browserLanguage">
            </v-select>
          </div>
        </div>
      </div>

      <div class="vx-row mt-1">
        <div class="vx-col w-1/2">
          <div class="mt-1">
            <label class="vs-input--label"> Валюта </label>
            <v-select :options="dictionary.currencies" placeholder="Выберите валюту" class="w-full" v-model="form.currency">
            </v-select>
          </div>
        </div>
        <div class="vx-col w-1/2">
          <div class="mt-1">
            <vs-input
                v-model.number="form.impsCount"
                type="number"
                autocomplete="off"
                label="Количество imp"
                placeholder="Введите число..."
                class="mt-1 w-full"
            />
          </div>
        </div>
      </div>

      <div class="vx-row mt-1">
        <!-- <div class="vx-col w-1/2 mb-1">
          <div class="mt-1">
            <vs-checkbox class="mt-3" icon="check" color="rgb(38, 187, 174)" v-model="form.machineLearning">
                  Машинное обучение</vs-checkbox
              >
          </div>
        </div> 
        <div class="vx-col w-1/2 mb-1">
          <div class="mt-1">
            <vs-checkbox class="mt-3" icon="check" color="rgb(38, 187, 174)" v-model="form.isFixedFit">
                  Использовать фикс</vs-checkbox
              >
          </div>
        </div>-->
      </div>

      <div class="vx-row mt-1">
        <div class="vx-col w-5/6 mb-1">
          <div class="mt-1">
            <vs-button class="mt-2" color="success" @click="loadData()" type="filled"> Применить </vs-button>
            <vs-button class="ml-5" color="rgb(250, 130, 80)" @click="resetData()" type="filled"> Очиситить </vs-button>
          </div>
        </div>
      </div>
    </form>

    <div class="mt-5" id="table-loader">
    <vs-table stripe :data="ads" pagination description
              :max-items="descriptionItems[2]"
              :description-items="descriptionItems"
              description-title="Registries"
              description-connector="of"
              description-body="Pages"
              class="mt-5 mb-3">
      <template slot="thead">
        <vs-th> ID </vs-th>
        <vs-th> Баннер </vs-th>
        <vs-th> Размеры (w/h)</vs-th>
        <vs-th> CPM </vs-th>
        <!-- <vs-th> Logs </vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="item" :key="indexItem" v-for="(item, indexItem) in data">
          <vs-td>
            BannerId:
            <router-link :to="{name: 'banner-edit', params: {id: item.id}}" target='_blank'>{{item.id}}</router-link>
            <br />
            CampaignId:
            <router-link :to="{name: 'campaign-edit', params: {id: item.campaignId}}" target='_blank'>{{item.campaignId}}</router-link>
            <br />
            CampaignName:<br />
            <router-link :to="{name: 'campaign-edit', params: {id: item.campaignId}}" target='_blank'>{{item.campaignName}}</router-link>
            <br />
            UserId:
            <router-link :to="{name: 'user-edit', params: {id: item.userId}}" target='_blank'>{{item.userId}}</router-link>
            <br />
            UserTypeId:{{ item.userTypeId }}
            <br />
            UserServiceTypeId:{{ item.userServiceTypeId }}

            <br />
            <br />
            <small>RequestId:{{ item.requestId }}</small>
            <br />
            <small>ImpId:{{ item.impId }}[{{item.seatBidIndex}}]</small>
            <br />
            <small>BidId:{{ item.bidId }}[{{item.bidIndex}}]</small>
          </vs-td>
          <vs-td class="center">
            <div v-html="item.htmlMarkup" class="vx-col"></div>
            <a :href="item.n_url" target="_blank">Показ</a>
            <br />
            <a :href="item.click_url" target="_blank">Клик</a>
          </vs-td>
          <vs-td>
            {{ item.width }}x{{ item.height }}
          </vs-td>
          <vs-td>
            {{item.cpmRub | formatNumber(2)}}₽ 
            <br /> 
            {{item.cpmUsd | formatNumber(3)}}$
          </vs-td>
          <!-- <vs-td><vs-button @click="getLog(item)">Лог</vs-button></vs-td> -->
        </vs-tr>
      </template>
    </vs-table>
    </div>

    <vs-popup title="Лог по объявлению" v-if="ad" :active.sync="popupView">
      <pre class="mb-2">{{ad.preCpmFormula}}</pre>
      <pre class="mb-2">{{ad.cpmFormula}}</pre>
      <pre class="mb-2">{{ad.clickPriceFormula}}</pre>
      <pre class="mb-2">{{ad.clickPriceWithCommissionFormula}}</pre>
      <pre class="mb-2">{{ad.sumClickPriceCommissionAgencyFormula}}</pre>
      <pre class="mb-2">{{ad.sumClickPriceCommissionFullServiceFormula}}</pre>
    </vs-popup>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';

import AD_TYPES from 'config/adTypes';

export default {
  name: 'debugging-page',
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      ads: [], // находятся ответы
      ad: undefined,
      popupView: false,
      descriptionItems: [3,5,15],
      form: {
        ssp: '',
        device: '',
        siteID: '',
        blockID: '',
        ageRates: [],
        contents: [],
        sourceID : '',
        requestID : '',
        userID : '',
        country: '',
        ip: '',
        domain: '',
        impsCount: 10,
        placesCount: 1,
        attributes: '',
        adTags: '',
        userAgent: '',
        browserLanguage: '',
        machineLearning: false,
        isFixedFit: false,
        currency: '',
        width: 300,
        height: 250
      },

      defaultForm: {
        ssp: {'value': 19, 'label': 'YandexBanners'},
        device: {'value': 1, 'label': 'компьютер'}, // все массивы забиваются значениями по умолчанию через загрузку.
        siteID: '',
        blockID: '',
        ageRates: [],
        contents: [],
        sourceID : '',
        requestID : '',
        userID : '',
        ip : '',
        domain : '',
        impsCount: 10,
        placesCount: 1,
        country: {'value': 'RU', 'label': 'Россия'},
        attributes: '',
        adTags: '',
        browserLanguage:{'value': 'ru', 'label': 'Русский'},
        currency: 'RUB'
      },

      dictionary: {
        ssp: [],
        contents: [],
        devices: [],
        countries: [],
        ageRates: [],
        genders: [],
        languages: [],
        currencies: ['RUB', 'USD']
      }
    };
  },

  mounted() {
    this.$axios({
      url: 'debugging/dicts',
      method: 'GET',
      params: { adTypeId: AD_TYPES.banner },
      success: (resp) => {
        this.$vs.loading.close('#loading-full-page > .con-vs-loading');

        if (resp.sspTypes) {
          for (let ssp_prop in resp.sspTypes) {
            this.dictionary.ssp.push({
              label: resp.sspTypes[ssp_prop].name,
              value: resp.sspTypes[ssp_prop].id
            });
          }

          this.dictionary.ssp.push({
              label: 'DirectAdvert [PG]',
              value: 100017
          });
        }

        if (resp.deviceTypes) {
          for (let devices_prop in resp.deviceTypes) {
            this.dictionary.devices.push({
              label: resp.deviceTypes[devices_prop].name,
              value: resp.deviceTypes[devices_prop].id
            });
          }
        }

        if (resp.ageRatings) {
          this.defaultForm.ageRates = [];
          for (let ages_prop in resp.ageRatings) {
            this.dictionary.ageRates.push({
              label: resp.ageRatings[ages_prop].name,
              value: resp.ageRatings[ages_prop].id
            });

            this.defaultForm.ageRates.push({
              label: resp.ageRatings[ages_prop].name,
              value: resp.ageRatings[ages_prop].id
            })
          }
        }

        if (resp.genders) {
          for (let genders_prop in resp.genders) {
            this.dictionary.genders.push({
              label: resp.genders[genders_prop].name,
              value: resp.genders[genders_prop].id
            });
          }
        }

        if (resp.contentTypes) {
          this.defaultForm.contents = [];
          for (let content_prop in resp.contentTypes) {
            this.dictionary.contents.push({
              label: resp.contentTypes[content_prop].name,
              value: resp.contentTypes[content_prop].id
            });


            this.defaultForm.contents.push({
              label: resp.contentTypes[content_prop].name,
              value: resp.contentTypes[content_prop].id
            })
          }
        }

        if (resp.countries) {
          for (let country_prop in resp.countries) {
            this.dictionary.countries.push({
              label: resp.countries[country_prop].name,
              value: resp.countries[country_prop].iso2
            });
          }
        }

        // browser languages
        if (resp.languages) {
          for (let language_prop in resp.languages) {
            this.dictionary.languages.push({
              label: resp.languages[language_prop].description,
              value: resp.languages[language_prop].name
            });
          }
        }
        this.setDefaultForm();
      },
      catch: (err) => {
        this.$vs.loading.close('#loading-full-page > .con-vs-loading');
        this.$vs.notify({
          title: 'Внимание!',
          text: 'Ошибка загрузки параметров.',
          color: 'danger'
        });
      }
    });
  },

  methods: {
    setDefaultForm() {
      Object.assign(this.form, JSON.parse(JSON.stringify(this.defaultForm)))
    },

    // загрузка данных
    loadData() {
      this.$vs.loading({
        container: '#table-loader',
        type: 'sound'
      });

      let attributes = [];
      this.form.attributes
        .split(',')
        .map((val) => { 
          let attrId = parseInt(val.trim()); 
          if (!isNaN(attrId)) attributes.push(attrId) 
        });

      let adTags = [];
      this.form.adTags
        .split(',')
        .map((val) => { 
          let adTagId = parseInt(val.trim()); 
          if (!isNaN(adTagId)) adTags.push(adTagId) 
        });

      let request = {
        'request_id': this.form.requestID,
        'user_id': this.form.userID,
        'source': this.form.sourceID,
        'site_id': this.form.siteID,
        'domain': this.form.domain,
        'block_id': this.form.blockID,
        'ssp': this.form.ssp.value,
        'country': this.form.country.value,
        'ip': this.form.ip,
        'device': this.form.device.value,
        'ageRates': this.form.ageRates.map(item => item.label),
        'contents': this.form.contents.map(item => item.value),
        'imps_count': this.form.impsCount,
        'places_count': this.form.placesCount,
        'attributes': attributes,
        'ad_tags': adTags,
        'userAgent':  this.form.userAgent,
        'browserLanguage':  this.form.browserLanguage.value,
        'machineLearning': this.form.machineLearning,
        'is_fixed_fit': this.form.isFixedFit,
        'currency': this.form.currency,
        'width': this.form.width,
        'height': this.form.height
      }

      this.axios.get(`debugging/page/banner`, {
        params: request,
        paramsSerializer: (params) => {
          return qs.stringify(params);
        }
      }).then((resp) => {
        if (resp.status === 204) {
          this.ads = [];
          return
        }

        const ads = resp.data.items;
        ads.forEach(i => {
          if (i.n_url) {
            i.n_url =i.n_url.replace('${AUCTION_PRICE}', i.cpmRub);
            i.click_url += '&n_url=http://ya.ru'
          }
        })
        this.ads = ads;
      }).
      catch((err) => {
        this.$vs.loading.close('#loading-full-page > .con-vs-loading');
        this.$vs.notify({
          title: 'Внимание!',
          text: 'Ошибка загрузки объявлений.',
          color: 'danger'
        });
      })
      .finally(() => {
        this.$vs.loading.close('#table-loader > .con-vs-loading');
      });
    },

    resetData() {
      this.setDefaultForm();
      this.loadData();
    },

    getLog(ad) {
      this.ad = ad;
      this.popupView = true;
    },
  },
};
</script>

<style lang="scss">
  .con-vs-popup .vs-popup {
    width: 1600px !important;
    height: auto !important;
  }
</style>
